import React from "react";
import ReactVisibilitySensor from "react-visibility-sensor";
import CountUp from "react-countup";
import classes from "./Counter.module.css";
import { useTranslation } from "react-i18next";

function Counter() {
  const { t } = useTranslation();

  return (
    <div className={classes.counterDiv}>
      <div className={classes.header}>
        <h4>{t("Strength in numbers.title")}</h4>
        <div class="bottom-arrow"></div>
      </div>
      <div className={classes.reachPoints}>
        <ReactVisibilitySensor>
          {({ isVisible }) => (
            <>
              <div className={classes.pointDiv}>
                <div className={classes.stats}>
                  <h3>{isVisible ? <CountUp enableScrollSpy={true} scrollSpyDelay={1000} duration={5} end={150} /> : "150"}</h3>
                </div>
                <h4>{t("Strength in numbers.h1")}</h4>
              </div>

              <div className={classes.pointDiv}>
                <div className={classes.stats}>
                  <h3>{isVisible ? <CountUp enableScrollSpy={true} scrollSpyDelay={1000} duration={5} end={20} /> : "20"}</h3>
                </div>
                <h4>{t("Strength in numbers.h2")}</h4>
              </div>
              {/* 
              <div className={classes.pointDiv}>
                <div className={classes.stats}>
                  <h3>
                    {isVisible ? <CountUp enableScrollSpy={true} scrollSpyDelay={1000} duration={5} end={8} /> : "8"}
                    K+
                  </h3>
                </div>
                <h4>Portfolios</h4>
              </div>

              <div className={classes.pointDiv}>
                <div className={classes.stats}>
                  <h3>${isVisible ? <CountUp enableScrollSpy={true} scrollSpyDelay={1000} duration={5} end={300} /> : "300"}M</h3>
                </div>
                <h4>Payroll</h4>
              </div> */}
            </>
          )}
        </ReactVisibilitySensor>
      </div>
    </div>
  );
}

export default Counter;
